<template>
  <button
    type="button"
    class="btn-region tw-block"
    @click.stop="openDialog"
  >
    <slot />
  </button>
</template>

<script>
import Vue from 'vue'
import i18n from '@ms/lang/i18n.js'
import modalHelper from '@ms/utils/scroll-fixed'
import { useSettingStore } from '@ms/stores/setting.js'
import { checkRegion } from './region.js'
import useSwitchRegion from './useStoreRegion'
import { isApp } from 'wap/hybrid/device'
import DialogRegionBox from './DialogRegionBox'

let hasChecked = false

let regionBox = null

const openRegionBox = ({ source, regionRedirectUrl }) => {
  if (regionBox) {
    return useSettingStore().toggleRegionBox(true)
  }
  const DialogRegionBoxConstructor = Vue.extend(DialogRegionBox)
  regionBox = new DialogRegionBoxConstructor({
    i18n,
    propsData: {
      source,
      regionRedirectUrl
    }
  }).$mount()

  document.querySelector('body').appendChild(regionBox.$el)
  useSettingStore().toggleRegionBox(true)
}

export default {
  props: {
    source: {
      type: String,
      default: ''
    },
    autocheck: {
      type: Boolean,
      default: false
    },
    regionRedirectUrl: {
      type: String,
      default: ''
    },
    // 不可切换国家
    noChangeRegion: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { ipRegion } = useSwitchRegion()
    return {
      ipRegion,
      disabled: isApp() || props.noChangeRegion
    }
  },
  data() {
    return {
      visible: false,
      autochecked: false,
      checkedRegion: this.$region
    }
  },
  mounted() {
    if (!this.disabled) {
      this.$watch('ipRegion', (val) => {
        if (val) {
          // 自动检测
          if (this.autocheck) {
            this.checkRegion()
          }
        }
      })
      // 自动检测
      this.autocheck && this.checkRegion()
    }
  },
  methods: {
    openDialog() {
      if (this.disabled) return
      const { source, regionRedirectUrl } = this
      openRegionBox({ source, regionRedirectUrl })
      modalHelper.afterOpen()
    },
    checkRegion() {
      if (isApp() || hasChecked) return
      const shouldChange = checkRegion(this.ipRegion)
      if (shouldChange) {
        this.autochecked = true
        this.openDialog()
        hasChecked = true
      }
    }
  }
}
</script>
